import { create } from "zustand";

interface SidebarStore {
  isCollapsed: boolean;
  isOpen: boolean; // mobile slide-in
  toggle: () => void;
  toggleMobile: () => void;
  closeMobile: () => void;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  isCollapsed:
    typeof window !== "undefined"
      ? localStorage.getItem("sidebarCollapsed") === "true"
      : false,
  isOpen: false,

  toggle: () =>
    set((s) => {
      const next = !s.isCollapsed;
      localStorage.setItem("sidebarCollapsed", String(next));
      document.documentElement.style.setProperty(
        "--sidebar-current-width",
        next ? "80px" : "260px",
      );
      return { isCollapsed: next };
    }),

  toggleMobile: () => set((s) => ({ isOpen: !s.isOpen })),

  closeMobile: () => set({ isOpen: false }),
}));
